import script from "./CRMWhatsappConversationFeedbackView.vue?vue&type=script&setup=true&lang=js"
export * from "./CRMWhatsappConversationFeedbackView.vue?vue&type=script&setup=true&lang=js"

import "./CRMWhatsappConversationFeedbackView.vue?vue&type=style&index=0&id=1d4e1bd1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d4e1bd1"]])

export default __exports__